import { call, put, takeLatest } from 'redux-saga/effects';
import { loadingRequest, loadingSuccess } from '@stores/global/actions.js';
import { delay } from '@helpers/utils/utils.js';
import { GlobalModal } from '@components/molecules/PopupModal/GlobalModal.jsx';
import { ErrorLevelConfig } from '@core/configureStore/ErrorLevelConfig.js';
import {
  setTrajetReportFunnelChartAction,
  setTrajetReportLeadAction,
  setTrajetReportLeadDetailAction,
  setTrajetReportLeadHistoryTableAction,
  setTrajetReportLOVAction,
  setTrajetReportTeamDataAction,
} from '@stores/trajetReport/actions.js';
import {
  GET_TRAJET_REPORT_FUNNEL_CHART_DATA,
  GET_TRAJET_REPORT_LEAD_DATA,
  GET_TRAJET_REPORT_LEAD_DETAIL_DATA,
  GET_TRAJET_REPORT_LEAD_HISTORY_TABLE_DATA,
  GET_TRAJET_REPORT_LOV_DATA,
  GET_TRAJET_REPORT_TEAM_DATA,
} from '@stores/trajetReport/constants.js';
import {
  getTrajetReportFunnelChartDataService,
  getTrajetReportLeadDataService,
  getTrajetReportLeadDetailDataService,
  getTrajetReportLeadHistoryTableDataService,
  getTrajetReportLOVDataService,
  getTrajetReportTeamDataService,
} from '@services/trajetReport/trajetReport.js';

export function* getTrajetReportLeadData({ payload, callback }) {
  try {
    yield put(loadingRequest());
    yield delay(1000);
    const response = yield call(getTrajetReportLeadDataService, payload);
    yield put(loadingSuccess());

    if (response && response.data) {
      yield put(setTrajetReportLeadAction(response.data));
    }
    if (callback) callback();
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getTrajetReportTeamData({ payload, callback }) {
  try {
    yield put(loadingRequest());
    yield delay(1000);
    const response = yield call(getTrajetReportTeamDataService, payload);
    yield put(loadingSuccess());

    if (response && response.data) {
      yield put(setTrajetReportTeamDataAction(response.data));
    }
    if (callback) callback();
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getTrajetReportFunnelChartData({ payload, callback }) {
  try {
    const response = yield call(getTrajetReportFunnelChartDataService, payload);

    if (response && response.data) {
      yield put(setTrajetReportFunnelChartAction(response.data));
    }
    if (callback) callback();
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getTrajetReportLeadDetailData({ payload, callback }) {
  try {
    yield put(loadingRequest());
    yield delay(1000);
    const response = yield call(getTrajetReportLeadDetailDataService, payload);
    yield put(loadingSuccess());

    if (response && response.data) {
      yield put(setTrajetReportLeadDetailAction(response.data));
    }

    if (callback) callback();
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getTrajetReportLeadHistoryTableData({ payload, callback }) {
  try {
    yield put(loadingRequest());
    yield delay(1000);
    const response = yield call(
      getTrajetReportLeadHistoryTableDataService,
      payload,
    );
    yield put(loadingSuccess());

    if (response && response.data) {
      yield put(setTrajetReportLeadHistoryTableAction(response.data));
    }

    if (callback) callback();
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getTrajetReportLOVData({ payload, callback }) {
  try {
    yield put(loadingRequest());
    yield delay(1000);
    const response = yield call(getTrajetReportLOVDataService, payload);
    yield put(loadingSuccess());

    if (response && response.data) {
      const groupByType = response.data?.reduce((acc, data) => {
        if (Object.keys(acc).includes(data.type)) {
          acc[data.type] = [...acc[data.type], data];
        } else {
          acc[data?.type] = [data];
        }
        return acc;
      }, {});
      yield put(setTrajetReportLOVAction(groupByType));
    }

    if (callback) callback();
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export default function* trajetReportSaga() {
  yield takeLatest(GET_TRAJET_REPORT_TEAM_DATA, getTrajetReportTeamData);
  yield takeLatest(GET_TRAJET_REPORT_LEAD_DATA, getTrajetReportLeadData);
  yield takeLatest(
    GET_TRAJET_REPORT_FUNNEL_CHART_DATA,
    getTrajetReportFunnelChartData,
  );
  yield takeLatest(
    GET_TRAJET_REPORT_LEAD_DETAIL_DATA,
    getTrajetReportLeadDetailData,
  );
  yield takeLatest(
    GET_TRAJET_REPORT_LEAD_HISTORY_TABLE_DATA,
    getTrajetReportLeadHistoryTableData,
  );
  yield takeLatest(GET_TRAJET_REPORT_LOV_DATA, getTrajetReportLOVData);
}
